import 'DialogModal/angularModule';
import 'Users/angularModule';

export default angular.module('FrontRoyal.ProgramSwitcher', ['DialogModal', 'FrontRoyal.Users']);
